<form [formGroup]='uploadPictures'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' i18n><span class='color-blue'>Add photos</span> of your furniture and boxes (optional)</div>

	<div class='step-text'>
		<p i18n>Get faster responses and more accurate quotes</p>
	</div>

	<div class='upload-zone'
	     [class.drag-over]='isDragOver'
	     (click)='fileInput.click()'
	     (drop)='onDrop($event)'
	     (dragover)='onDragOver($event)'
	     (dragenter)='onDragEnter($event)'
	     (dragleave)='onDragLeave($event)'>
		<input #fileInput
		       type='file'
		       [attr.accept]='acceptTypes'
		       multiple
		       (change)='onFileSelect($event)'
		       class='upload-input'>
		<div class='upload-icon'>
			<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'>
				<path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'/>
				<polyline points='17 8 12 3 7 8'/>
				<line x1='12' y1='3' x2='12' y2='15'/>
			</svg>
		</div>
		<div class='upload-label' i18n>Upload your photos</div>
		<div class='upload-hint' i18n>Up to {{ maxImages }} images - {{ maxSize }} total</div>
	</div>

	<div *ngIf='uploadErrorMessage' class='upload-error'>{{ uploadErrorMessage }}</div>

	<div class='preview-grid' *ngIf='displayItems.length > 0'>
		<div *ngFor='let item of displayItems; let i = index; trackBy: trackByPreviewItem' class='preview-item' [class.uploading]='item.isUploading'>
			<img [src]='item.previewUrl' [alt]='item.file.originalName' class='preview-img'>
			<div *ngIf='item.isUploading' class='preview-uploading'>
				<div class='loader'>
					<div class='loader-spinner'></div>
				</div>
			</div>
			<button *ngIf='!item.isUploading' type='button' class='preview-remove' (click)='removeFile( i )'><mat-icon svgIcon='vc:close'></mat-icon></button>
		</div>
	</div>

	<div class='step-footer step-footer-center'>

		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>

	</div>
</form>
